import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { authAPI } from '../services/adminApi';

const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  
  if (!authAPI.isAuthenticated()) {
    return <Navigate to="/admin/login" state={{ from: location }} replace />;
  }
  
  return children;
};

export default ProtectedRoute;
